import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import PaymentModalStore from './store';

const styles = require('./index.less');

const PaymentModal = ({ store, onClose }) => {
  store.use();
  if (typeof onClose === 'function') {
    store.onClose = onClose;
  }
  return (
    <ModalContainer modalState={store.isOpen}>
      <section className={styles.panel} aria-label="礼包支付弹窗">
        <div className={styles.header}>礼包支付</div>
        <button className={styles.close} type="button" aria-label="关闭支付弹窗" onClick={store.onClickClose}>
          ×
        </button>
        <iframe className={styles.iframe} title="逍遥网支付" frameBorder="0" scrolling="auto" src={store.payUrl} />
      </section>
    </ModalContainer>
  );
};

export { PaymentModal };
export default wrapStore(PaymentModal, PaymentModalStore);
